export default "__VITE_ASSET__DVfMXnD8__"